// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"styles_accordionContainer__1oo_8"};